import { render } from "./CustomerOverview.vue?vue&type=template&id=921946e2&scoped=true"
import script from "./CustomerOverview.vue?vue&type=script&lang=js"
export * from "./CustomerOverview.vue?vue&type=script&lang=js"

import "./CustomerOverview.vue?vue&type=style&index=0&id=921946e2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-921946e2"],['__file',"src/views/h5/crm/customer/CustomerOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "921946e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('921946e2', __exports__)) {
    api.reload('921946e2', __exports__)
  }
  
  module.hot.accept("./CustomerOverview.vue?vue&type=template&id=921946e2&scoped=true", () => {
    api.rerender('921946e2', render)
  })

}


export default __exports__